import React from "react";
import AppButton from "./AppButton";

/**
 * Reusable single-field edit modal.
 *
 * Props:
 *   open        - boolean — whether modal is visible
 *   title       - modal header title
 *   label       - input label text
 *   value       - current input value
 *   placeholder - input placeholder
 *   onChange    - (e) => void
 *   onSubmit    - form submit handler
 *   onClose     - close handler
 *   submitLabel - submit button text (default "Update")
 */
const SingleFieldEditModal = ({
  open,
  title,
  label,
  value = "",
  placeholder = "",
  onChange,
  onSubmit,
  onClose,
  submitLabel = "Update",
  loading = false,
}) => {
  if (!open) return null;

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content rr-manageCard">
            <div className="modal-header border-0 pb-1">
              <h5 className="modal-title">{title}</h5>
              <AppButton
                variant="outline"
                onClick={onClose}
                style={{ padding: "2px 10px", lineHeight: 1, minWidth: "unset" }}
                title="Close"
                disabled={loading}
              >
                ×
              </AppButton>
            </div>
            <form onSubmit={onSubmit}>
              <div className="modal-body">
                <label className="form-label rr-label">{label}</label>
                <input
                  type="text"
                  className="form-control rr-input"
                  value={value}
                  placeholder={placeholder}
                  onChange={onChange}
                  required
                  autoFocus
                  disabled={loading}
                />
              </div>
              <div className="modal-footer border-0 justify-content-end d-flex gap-2">
               
                <AppButton type="button" variant="secondary" onClick={onClose} disabled={loading}>
                  Cancel
                </AppButton>

                 <AppButton type="submit" variant="fill" disabled={!value.trim() || loading}>
                  {loading ? "Updating..." : submitLabel}
                </AppButton>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" />
    </>
  );
};

export default SingleFieldEditModal;
